<template>
    <div >
        <modal
        class="new-modal-default modal-cover create-configure-shift-work custom-lgflexible-width"
        transition="nice-modal-fade"
        :name="modal_name" id="modal_append_body"
        :delay="100" :clickToClose="false"
        height="auto"
        :width="400"
        :adaptive="true" :scrollable="true"
        >
            <div v-if="ajaxCall" class="checkoutLoader">
                <div class="LoaderPlacement">
                        <div class="digi-table-loader">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                </div>
            </div>
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="mt-4 px-5">
                    <span class="text-new-blue fs-20 fw-600" v-if="mode == 'create'">Create New Template</span>
                    <span class="text-new-blue fs-20 fw-600" v-else>Edit {{ template_name || '' }} Template</span>
                    <div>
                        <span class="fs-12 mt-1" style="color: #0066d0;">
                            Part 1: Add Basic Info
                        </span>
                    </div>
                </div>
                <div class="v-modal-body pb-2 pt-2">
                    <div class="v-modal-layout">
                        <div class="bg-light-grey temp-styles p-4">
                            <div class="d-flex align-items-center mb-2 pr-6">
                                <span class="fw-600 fs-16 text-nowrap pl-3">Template Details</span>
                                <div class="ml-2" style="width:100%;border-bottom:1px solid #a5a5a5"></div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-6 col-sm-12 pr-10">
                                    <div class="form-group contactGroup pt-0">
                                        <label class="inputLabel fs-14 fw-500 pl-2 text-black">Template Name <span class="text-danger"> *</span></label>
                                        <!-- <input v-validate="'required'" name="template_name" autocomplete="off" data-vv-as="Template Name" class="newInputField overflowing-text mt-1 fs-14 fw-500 ml-3" style="padding-right: 30px !important;background-color: #f1f1f1 !important; " type="text" :maxlength="templateNamelength" v-model="template_name" placeholder="Enter Template Name" /> -->
                                        <input type="text" class="newInputField overflowing-text mt-1 fs-14 fw-500 ml-3" style="padding-right: 30px !important;background-color: #f1f1f1 !important;" v-validate="'required'" name="template_name" autocomplete="off" data-vv-as="Template Name" v-model="template_name" @input="checkDuplicateTemplate" placeholder="Enter Template Name" />
                                        <span class="inputBorder"></span>
                                        <span class="pull-right text-right font-600 fs-12 pt-1">{{ templateNamelength - template_name.length}}/{{templateNamelength}}</span>
                                        <span class="invalid-feedback-form text-danger mt-0 text-left d-block ml-2" v-show="errors.has('template_name')" style="display: inline !important">{{ errors.first("template_name") }}</span>
                                        <span class="invalid-feedback-form text-danger mt-0 text-left d-block ml-2" v-if="check_duplicate_template" style="display: inline !important">{{ check_duplicate_text }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <label class="inputLabel fs-14  fw-500 text-black pl-2">Select Template Type <span class="text-danger"> *</span></label>
                                    <el-radio-group class="d-flex radio-custom justify-content-between align-items-center mt-3 mob-issue-fix pl-2 ml-1" v-validate="'required'" name="selected_template" v-model="selected_template" @change="addPartNameReset">
                                        <el-radio label="default">
                                            Default
                                        </el-radio>
                                        <el-radio label="multi_part">
                                            Multi-part 
                                            <sup>
                                                <el-tooltip class="item" effect="dark" content="Parts must range from 2 to 5" placement="top">
                                                    <i class="ri-2x ri-information-line text-black fs-16 mt-3 mr-2" style="position:relative;bottom:5px"></i>
                                                </el-tooltip>
                                            </sup>
                                        </el-radio>
                                    </el-radio-group>
                                    <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('selected_template')" style="display: inline !important">{{ errors.first('selected_template') }}</span> 
                                </div>
                                <div class="col-lg-5 col-md-6 col-sm-12" v-if="selected_template == 'multi_part'">
                                    <div class="d-flex mt-6">
                                        <div class="w-100">
                                            <input name="no_of_parts" v-validate="'required'" data-vv-as="No. of parts" class="newInputField overflowing-text mt-1 fs-15 fw-500" onkeypress="return event.charCode >= 50 && event.charCode <= 53" @input="AddMultiPart"
                                            style="padding-right: 30px !important;" type="text" 
                                            :maxlength="1" v-model="no_of_parts" placeholder="Enter no. of parts required" />
                                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('no_of_parts')" style="display: inline !important">{{ errors.first('no_of_parts') }}</span> 
                                        </div>
                                        <!-- <button class="btn btn-secondary pointer ml-4 mt-1" style="border-radius:3px;height:40px" :disabled="temp_no_parts == no_of_parts || no_of_parts == ''" @click="AddMultiPart">Add</button> -->
                                    </div>
                                </div>
                            </div>
                            <div v-if="selected_template == 'multi_part'" class="mt-4 ml-2">
                                <label class="inputLabel fs-14  fw-500 text-black  mb-0">Add Part Name<span class="text-danger"> *</span></label>
                                <div class="row">
                                    <div class="col-lg-3 col-md-6 col-sm-12" v-for="(part, part_index) in multi_part_fields" :key="part_index">
                                        <div class="form-group contactGroup pt-0">
                                            <div class="d-flex">
                                                <!-- @input="checkDuplicate" -->
                                                <input :name="'part_name' + part_index+1" :data-vv-as="`Part Name ${ part_index+1}`" 
                                                class="newInputField overflowing-text fs-15 fw-500" v-validate="'required'" autocomplete="off"
                                                style="padding-right: 30px !important;" type="text" 
                                                :maxlength="30" v-model="part.name" :placeholder="`Part Name ${ part_index+1}`" />
                                                <i class="icon icon-minus-circle text-danger pointer ml-1 mt-5" v-if="multi_part_fields.length >= 3" @click="removePart(part_index)"></i>
                                            </div>
                                            <span class="inputBorder"></span>
                                            <span class="pull-right text-right font-600 fs-12 pt-1">{{ 30 - part.name.length}}/{{30}}</span>
                                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('part_name' + part_index+1)" style="display: inline !important;width:200px">{{ errors.first('part_name' + part_index+1) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <span v-if="isDuplicate" class="invalid-feedback-form text-danger mt-0 text-left d-block" style="display: inline !important">The Part Names must be Unique</span>
                                <span v-if="parts_validation" class="invalid-feedback-form text-danger mt-0 text-left d-block" style="display: inline !important">The Part Field not matching number of parts</span>
                            </div>
                        </div>
                        <div class="bg-light-grey temp-styles p-3 mt-3" v-if="selected_template == 'multi_part'">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <!-- <label class="inputLabel fs-14 text-secondary fw-600 text-black pl-1">Approval For Multi-Part Template</label> -->
                                    <div class="d-flex align-items-center mb-2 pr-6">
                                        <span class="fw-600 fs-16 text-nowrap pl-3">Approval For Multi-Part Template</span>
                                        <div class="ml-2" style="width:100%;border-bottom:1px solid #a5a5a5"></div>
                                    </div>
                                    <div class="d-flex ml-3 mt-2">
                                        <el-checkbox :value="add_approver" @change="approverToggle($event)" class="mb-0 mr-2"></el-checkbox>
                                        <div class="ml-1 fw-500">Add Approver to approve each part</div>
                                    </div>
                                </div>
                            </div>
                            <label class="inputLabel fs-14  fw-600  pl-1 mt-4 ml-2" style="color: #4e4e4e;" v-if="add_approver">Add Approver</label>
                            <div class="row" v-if="add_approver">
                                <div class="col-lg-4 col-md-4 col-sm-12 pl-6" v-for="(app, app_index) in approvers" :key="app_index">
                                    <div class="d-flex align-items-center">
                                        <multiselect
                                            v-model="approvers[app_index]"
                                            v-validate="add_approver ? 'required' : ''"
                                            style="width:400px;border:none !important;"
                                            autocomplete="off"
                                            class="diginew-multiselect fw-500 spinner-bg bg-multi mt-3 fs-14 tagStyle"
                                            :options="approvers_options"
                                            :data-vv-as="`Approver ${app_index + 1}`"
                                            :searchable="true"
                                            :loading="approvers_loading && app_index == current_approver_loader"
                                            :close-on-select="true"
                                            :name="'approver'+ app_index"
                                            :show-labels="false"
                                            :multiple="false"
                                            :allow-empty="false"
                                            @search-change="searchApproversData"
                                            @open="LoadApproversData(app_index)"
                                            :options-limit="3000"
                                            :max-height="200"
                                            :clear-on-select="false"
                                            label="name"
                                            :internal-search="false"
                                            :show-no-results="true"
                                            :hide-selected="false"
                                            >
                                                <template slot="placeholder">
                                                    <span class="diginewhelp-multiselect">Select Approver</span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfApprovers" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                        </multiselect>
                                        <i class="icon icon-close text-black clear-icon-new tagClear mt-3 pointer fs-21" v-if="app != '' && !approvers_loading" @click="clearApprover(app_index)"></i>
                                        <i class="icon icon-minus-circle text-danger pointer ml-1 mt-3" v-if="approvers.length > 1" @click="removeApprover(app_index)" ></i>
                                        <!-- <div class="d-flex align-items-center pointer ml-1" @click="addApprover" v-if="app_index == approvers.length-1 && app_index < 4">
                                            <i class="icon icon-plus-circle text-success mt-3"></i>
                                            <span class="text-nowrap mt-3">Add Approver</span>
                                        </div> -->
                                    </div>
                                    <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('approver'+ app_index)" style="display: inline !important">{{ errors.first('approver'+ app_index) }}</span> 
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center" v-if="add_approver">
                                <div></div>
                                <div class="d-flex align-items-center pointer ml-1" @click="addApprover" v-if="approvers.length <= 4">
                                    <i class="icon icon-plus-circle text-success mt-3"></i>
                                    <span class="text-nowrap mt-3">Add Approver</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="v-modal-footer d-flex justify-content-between align-items-center mb-5 mt-2 mr-6"> 
                    <div></div>
                    <div>
                        <button class="btn btn-danger-new text-white w-150px mr-8" @click="hideModal">Cancel</button>
                        <button class="btn text-white w-150px" style="border-radius:5px !important;font-weight:500 !important;text-transform: capitalize;" v-if="!check_loader"
                                :class="mode == 'create' ? 'btn-green' : 'btn-secondary'" @click="storeTemplateData">
                            {{ mode == 'create' ? 'Create' : 'Edit' }} Template
                        </button>
                        <button class="btn btn-success w-150px" disabled v-else>
                            Checking...
                            <half-circle-spinner :animation-duration="1000" :size="20" color="#00448b" style="position: absolute;right: 10px; top: 8px;" />
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
// import setting from '../../mixins/setting'
import { HalfCircleSpinner } from "epic-spinners";
import {SweetModal} from 'sweet-modal-vue';
import dynamic_template from '../../mixins/dynamic_template';
import ticket from '../../mixins/ticket'
import debounce from 'lodash/debounce';
import {EventBus} from '../../eventBus/nav-bar-event.js';
export default{
    mixins: [ticket, dynamic_template],
    props: ["modal_name", "mode", "selected_template_id"],
    components:{
        SweetModal,
        HalfCircleSpinner
    },
    data(){
        return{
            success_msg: '',
            warning_msg: '',
            template_name: '',
            selected_template: 'default',
            templateNamelength: 100,
            no_of_parts: 2,
            temp_no_parts: 2,
            nopartslength: 10,
            add_approver: false,
            approvers: [],
            multi_part_fields: [],
            temp_multi_details: [],
            default_fields: [],
            approvers_loading: false,
            approvers_scrollable: false,
            approvers_count: 0,
            approvers_options: [],
            temp_approvers_options: 0,
            temp_approvers: [],
            current_approver_loader: 0,
            parts_validation: false,
            approvers_search_key: '',
            ajaxCall: false,
            check_loader: false,
            check_duplicate_template: false,
            check_duplicate_text: '',
        }
    },
    methods:{
        checkDuplicate(){
            var temp_multi_part_fields = this.multi_part_fields.map(x => x.name);
            this.isDuplicate = temp_multi_part_fields.some((item, idx) => {
                return temp_multi_part_fields.indexOf(item) != idx 
            })
        },
        hideModal(){
            localStorage.removeItem('storedTemplateData')
            if(this.$route.query.call_type='redirection_mode'){
                this.$router.push('/settings?type=templatesnew') 
            }
            this.$modal.hide('CreateTemplatePopup')
            this.$emit('closeCreateTemplate')
        },
        addApprover(){
            this.approvers.push('')
        },
        clearApprover(index){
            this.approvers.splice(index, 1, '')
        },
        removeApprover(index){
            console.log("hello")
            this.approvers.splice(index, 1);
            setTimeout(() => {
                this.$validator.validateAll()     
            }, 10);
        },
        addPartNameReset(){
            if(this.selected_template == 'multi_part'){
                this.no_of_parts = '2'
                this.temp_no_parts = 2
                this.multi_part_fields = [
                    {
                        name: '',
                        fields: [
                            {
                                required: false,
                                type: '',
                                name: '',
                                possible_values: ['', ''],
                                statement: false,
                                add_attachments: false,
                                is_duplicate: false,
                                is_questions_duplicate: false
                            }
                        ],
                    },
                    {
                        name: '',
                        fields: [
                            {
                                required: false,
                                type: '',
                                name: '',
                                possible_values: ['', ''],
                                statement: false,
                                add_attachments: false,
                                is_duplicate: false,
                                is_questions_duplicate: false
                            }
                        ],
                    }
                ]
            }
        },
        AddMultiPart(){
            this.temp_no_parts = this.no_of_parts
            let parts = parseInt(this.no_of_parts)
            if(this.multi_part_fields.length > parts){
                let temp_arr = []
                for(let i=0; i<parts; i++){
                    temp_arr.push(this.multi_part_fields[i])
                }
                this.multi_part_fields = [...temp_arr]
            } else if(this.multi_part_fields.length < parts){
                let t = parts - this.multi_part_fields.length
                for(let i=0; i<t; i++){
                    this.multi_part_fields.push({
                        name: '',
                        fields: [
                            {
                                required: false,
                                type: '',
                                name: '',
                                possible_values: ['', ''],
                                statement: false,
                                add_attachments: false,
                                is_duplicate: false,
                                is_questions_duplicate: false
                            }
                        ],
                    })
                }
            }
            if(this.no_of_parts != this.multi_part_fields.length){
                this.parts_validation = true
            } else {
                this.parts_validation = false
            }
        },
        removePart(index) {
            this.multi_part_fields.splice(index, 1)
            // this.parts_validation = this.no_of_parts !== this.multi_part_fields.length
            this.no_of_parts = this.multi_part_fields.length
        },

        async LoadApproversData(index){
            this.current_approver_loader = index
            this.approvers_options = []
            this.approvers_count = 0
        },
        async searchApproversDataDebouncer(search_key){
            this.approvers_count = 0
            this.approvers_options = []
            this.approvers_loading = true
            this.approvers_search_key = search_key || ''
            try{
                let params = {
                    skip:0,
                    limit:10,
                    search_key: this.approvers_search_key,
                    exclude_ids: this.approvers_ids
                }
                let response = await this.getUserForTickets(params)
                this.approvers_options = response.response.assigned_user_details
                let uniqueArray = this.approvers_options.filter((value, index_dd) => {
                    const _value = JSON.stringify(value);
                    return index_dd === this.approvers_options.findIndex(obj => {
                        return JSON.stringify(obj) === _value;
                    });
                });
                this.approvers_options = uniqueArray
                this.approvers_count += response.response.assigned_user_details.length;
                this.approvers_loading = false
            } catch(err) {
                this.approvers_loading = false
                console.log(err)
            }
        },
        async reachedEndOfApprovers(reached){
            if (reached) {
                if(this.approvers_scrollable == false){
                    this.approvers_loading = true
                    let response = await this.getUserForTickets({
                        skip: this.approvers_count,
                        limit: 10,
                        search_key: this.approvers_search_key,
                        exclude_ids: this.approvers_ids
                    })
                    let temp_approvers_options = response.response.assigned_user_details.length;
                    if(response.response.skip == this.approvers_count){
                        if(temp_approvers_options > 0){
                            let tempfiles = response.response.assigned_user_details
                            tempfiles.forEach(el => {
                                this.approvers_options.push(el)
                            })
                            let uniqueArray = this.approvers_options.filter((value, index_dd) => {
                                const _value = JSON.stringify(value);
                                return index_dd === this.approvers_options.findIndex(obj => {
                                    return JSON.stringify(obj) === _value;
                                });
                            });
                            this.approvers_options = uniqueArray
                            this.approvers_count += response.response.assigned_user_details.length;
                            this.approvers_loading = false
                        } else {
                            this.approvers_scrollable = true
                            this.approvers_loading = false
                        }
                        this.approvers_scrollable = false
                    }
                }
            }
        },
        async checkDuplicateTemplate(){
            console.log("check duplicate")
            let params = {
                template_name: this.template_name
            }
            let response = await this.checkDuplicateTemplateName(params)
            if(response.status_id == 0){
                this.check_duplicate_template = true
                this.check_duplicate_text = "Template Name Already Exist"
            } else {
                this.check_duplicate_template = false
                this.check_duplicate_text = " "
            }
        },
        async storeTemplateData(){
            this.$validator.validateAll().then(async result => {
                if(result && !this.check_duplicate_template && (!this.parts_validation || this.selected_template == 'default')){
                    if(this.mode == 'create'){
                        try{
                            this.check_loader = true
                            let params = {
                                template_name: this.template_name
                            }
                            let response = await this.checkDuplicateTemplateName(params)
                            if(response.status_id == 0){
                                // this.warning_msg = response.reason
                                // this.$refs.success_modal.open()
                                // setTimeout(() => {
                                //     this.check_loader = false
                                //     this.$refs.success_modal.close()
                                // }, 2000);
                            } else {
                                this.template_data.mode = this.mode
                                if(this.mode == 'edit'){
                                    this.template_data.template_id = this.selected_template_id
                                }
                                let payload = JSON.stringify(this.template_data);
                                localStorage.setItem('storedTemplateData', payload)
                                EventBus.$emit('ZindexChangeEnd')
                                if(this.mode == 'create'){
                                    this.$router.push('/dynamictemplate/create')
                                } else {
                                    this.$router.push('/dynamictemplate/edit/'+this.selected_template_id)
                                }
                                this.check_loader = false
                            }
                        } catch(err) {
                            this.check_loader = false
                            // this.warning_msg = err
                            // this.$refs.warning_modal.open()
                            // setTimeout(() => {
                            //     this.$refs.warning_modal.close()
                            // }, 2000);
                        }
                    } else {
                        this.template_data.mode = this.mode
                        if(this.mode == 'edit'){
                            this.template_data.template_id = this.selected_template_id
                            if(this.template_data.template_type == 'default' && this.template_data.template_data.length == 0){
                                this.template_data.template_data = [{
                                    required: false,
                                    type: '',
                                    name: '',
                                    possible_values: ['', ''],
                                    statement: false,
                                    add_attachments: false,
                                    is_duplicate: false,
                                    is_questions_duplicate: false
                                }]
                            }
                        }
                        let payload = JSON.stringify(this.template_data);
                        localStorage.setItem('storedTemplateData', payload)
                        if(this.mode == 'create'){
                            this.$router.push('/dynamictemplate/create')
                        } else {
                            this.$router.push('/dynamictemplate/edit/'+this.selected_template_id)
                        }
                    }
                }
            })
        },
        approverToggle(event){
            this.add_approver = event
            if(this.mode == 'create'){
                if(this.add_approver){
                    this.approvers = []
                    this.approvers.push('') 
                } else {
                    this.approvers = []
                }
            } else {
                if(this.add_approver){
                    if(this.temp_approvers.length == 0){
                        this.approvers = []
                        this.approvers.push('')
                    } else {
                        this.approvers = JSON.parse(JSON.stringify(this.temp_approvers))
                    }   
                } else {
                    this.approvers = []
                }
            }
        },
        async getTemplateData(id){
            try{
                let param = {
                    dynamic_template_id: id
                };
                let response = await this.getDynamicTemplate(param)
                this.template_name = response.response.name;
                this.selected_template = response.response.template_type
                if(this.selected_template == 'default'){
                    this.default_fields = response.response.fields
                }
                this.no_of_parts = response.response.number_of_parts
                this.temp_no_parts = response.response.number_of_parts
                if(response.response.hasOwnProperty('multi_parts_data')){
                    this.multi_part_fields = response.response.multi_parts_data
                    this.temp_multi_details = JSON.parse(JSON.stringify(this.multi_part_fields))
                }
                this.add_approver = response.response.approve_data.length > 0 ? true : false
                this.approvers = response.response.approve_data
                this.temp_approvers = response.response.approve_data
                this.$forceUpdate();
                // this.
            } catch(err){
                console.log(err)
            }
        }
    },
    watch: {
        'no_of_parts': function(params){
            if(params != this.multi_part_fields.length){
                this.parts_validation = true
            } else {
                this.parts_validation = false
            }
        }
    },
    computed:{
        loggedInUser(){
            return this.$store.state.store.loggedInUser
        },
        template_data(){
            return{
                name: this.template_name,
                template_type: this.selected_template,
                number_of_parts: this.multi_part_fields.length,
                multi_parts_data: this.multi_part_fields,
                approve_data: this.approvers,
                template_data: this.default_fields
            }
        },
        approvers_ids(){
            let temp_approvers_data = []
            this.approvers.forEach((x) => {
                if(x.hasOwnProperty('id')){
                    temp_approvers_data.push(x)
                }
            })
            // temp_approvers_data.push({
            //     id: this.loggedInUser.user_id
            // })
            return temp_approvers_data.length > 0 ? temp_approvers_data.map(x => x.id) : []
        },
        searchApproversData(){
            return debounce(this.searchApproversDataDebouncer, 500)
        }
    },
    mounted(){
        // setTimeout(() => {
        //     document.body.appendChild(document.getElementById('modal_append_body'))
        // }, 1000);
    },
    created(){
        if(localStorage.getItem('storedTemplateData')){
            let temp_template_data = JSON.parse(localStorage.getItem('storedTemplateData'))
            this.mode = temp_template_data.mode
            this.$emit('reload_template_id', temp_template_data.template_id)
            this.template_name = temp_template_data.name;
            this.selected_template = temp_template_data.template_type
            if(this.selected_template == 'default'){
                this.default_fields = temp_template_data.template_data
            }
            this.no_of_parts = temp_template_data.number_of_parts
            this.temp_no_parts = temp_template_data.number_of_parts
            if(temp_template_data.hasOwnProperty('multi_parts_data')){
                this.multi_part_fields = temp_template_data.multi_parts_data
                this.temp_multi_details = JSON.parse(JSON.stringify(this.multi_part_fields))
            }
            this.add_approver = temp_template_data.approve_data.length > 0 ? true : false
            this.approvers = temp_template_data.approve_data
            this.temp_approvers = temp_template_data.approve_data
        } else {
            if(this.mode == 'edit' && this.selected_template_id){
                this.getTemplateData(this.selected_template_id)
            }
        }
    }
}
</script>

<style scoped>
.newInputField {
    font-size: 14px !important;
    padding: 10px 18px 7px 9px !important;
    display: block;
    width: 100%;
    border: none;
    background: transparent !important;
    color: #303031;
    font-weight: 600;
    border-radius: 5px !important;
    margin-top: 12px;
    background-color: #f1f1f1 !important;
}


.text-new-blue{
    color: #00448b;

}
.inputLabel {
    margin-left: 6px;
}
.v-modal-body{
    padding-left:20px;
    padding-right: 20px;
}
.bg-light-grey{
    /* background-color: rgba(0, 0, 0, 0.05) !important; */
    background-color: #fff !important;
    border: 0.5px solid #0d84f2 !important;
}
.temp-styles{
    border-radius: 10px
}
.btn-secondary-outline{
    border-radius: 5px !important;
    border: solid 1px #F44336 !important;
    color: #F44336 !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    background-color: transparent;
}
.btn-secondary-outline:hover{
    background-color: #F44336 !important;
    color: #fff !important;
    border-radius: 5px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    background-color: transparent;
}
.w-150px{
    width: 150px !important;
}
.inputFieldNew{
    font-weight: 500 !important;
    border-radius: 7px !important;
}
.btn-secondary{
    padding:0 20px;
    color: #fff;
    background-color: #00448f;
    border-color: #00448f;
    border-radius: 10px !important;
    box-shadow: none !important;
    font-weight: 600;
}
.clear-icon{
    position: absolute;
    top:10px;
    left:392px;
    background-color: #fff;
}
.clear-icon-new{
    position: absolute;
    top:10px;
    left:300px;
    background-color: #fff;
}
.position-absolute{
    position: absolute;
}
.fs-15{
    font-size: 15px !important;
}
.fs-21{
    font-size: 21px !important
}
</style>